(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-access"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const translations=new Map([
      ['Sign up','Demander un accès professionnel'],
      ['Complete the form to sign up.','Complétez le formulaire pour demander votre accès professionnel.'],
      ['Submit','Envoyer ma demande'],
      ['Success','Demande envoyée'],
      ['Thank you. The form has been submitted.','Votre demande a bien été transmise. Nous vous répondrons après vérification de votre activité.'],
      ['Email me news and offers','Recevoir les actualités et offres par e-mail'],
      ['Text me news and offers','Recevoir les actualités et offres par SMS']
    ]);
    const translateRoot=root=>{
      const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
      let node;
      while((node=walker.nextNode())){
        const value=node.nodeValue.trim();
        if(translations.has(value))node.nodeValue=node.nodeValue.replace(value,translations.get(value));
      }
    };
    const connect=embed=>{
      if(embed.dataset.noveoTranslated)return;
      embed.dataset.noveoTranslated='true';
      const apply=()=>embed.shadowRoot&&translateRoot(embed.shadowRoot);
      apply();
      if(embed.shadowRoot)new MutationObserver(apply).observe(embed.shadowRoot,{childList:true,subtree:true,characterData:true});
    };
    const scan=()=>document.querySelectorAll('[data-noveo-b2b-shopify-form] shopify-forms-embed').forEach(connect);
    customElements.whenDefined('shopify-forms-embed').then(scan);
    new MutationObserver(scan).observe(document.documentElement,{childList:true,subtree:true});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const submitCart=control=>{const form=control.closest('form');const updateButton=form?.querySelector('button[name="update"]');if(form&&updateButton)form.requestSubmit(updateButton)};
  const syncDecreaseIcon=control=>{const input=control.querySelector('input[name="updates[]"]');const decrease=control.querySelector('[data-cart-quantity-decrease]');const isRemove=Number(input.value)<=1;decrease.querySelector('[data-cart-minus]').hidden=isRemove;decrease.querySelector('[data-cart-trash]').hidden=!isRemove;decrease.setAttribute('aria-label',isRemove?decrease.dataset.removeLabel:decrease.dataset.decreaseLabel)};
  document.querySelectorAll('.noveo-cart-quantity').forEach(syncDecreaseIcon);
  document.addEventListener('click',event=>{const button=event.target.closest('[data-cart-quantity-decrease],[data-cart-quantity-increase]');if(!button)return;const control=button.closest('.noveo-cart-quantity');const input=control.querySelector('input[name="updates[]"]');const minimum=Number(input.min)||0;const maximum=Number(input.max)||Infinity;const step=Number(input.step)||1;const direction=button.hasAttribute('data-cart-quantity-increase')?1:-1;const current=Number(input.value)||0;input.value=String(Math.min(maximum,Math.max(minimum,current+direction*step)));syncDecreaseIcon(control);submitCart(control)});
  document.addEventListener('change',event=>{const input=event.target.closest('.noveo-cart-quantity input[name="updates[]"]');if(!input)return;const control=input.closest('.noveo-cart-quantity');input.value=String(Math.max(0,Number(input.value)||0));syncDecreaseIcon(control);submitCart(control)});
  document.addEventListener('click',async event=>{const button=event.target.closest('.noveo-buyer-protection__toggle');if(!button)return;const protection=button.closest('[data-buyer-protection]');const isActive=protection.classList.contains('is-active');const error=protection.querySelector('[data-protection-error]');button.disabled=true;error.hidden=true;try{const endpoint=isActive?'cart/change.js':'cart/add.js';const payload=isActive?{id:protection.dataset.lineKey,quantity:0}:{items:[{id:Number(protection.dataset.variantId),quantity:1}]};const response=await fetch(window.Shopify.routes.root+endpoint,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});if(!response.ok)throw new Error('Cart update failed');window.location.reload()}catch(cartError){error.hidden=false;button.disabled=false}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];const thumbnails=[...gallery.querySelectorAll('[data-gallery-thumbnail]')];const current=gallery.querySelector('[data-gallery-current]');let active=Math.max(0,slides.findIndex(slide=>!slide.hidden));const show=index=>{if(!slides.length)return;active=(index+slides.length)%slides.length;slides.forEach((slide,slideIndex)=>{slide.hidden=slideIndex!==active});thumbnails.forEach((thumbnail,thumbnailIndex)=>{thumbnail.setAttribute('aria-current',thumbnailIndex===active?'true':'false')});if(current)current.textContent=String(active+1);thumbnails[active]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'})};gallery.showMedia=mediaId=>{const index=slides.findIndex(slide=>slide.dataset.mediaId===String(mediaId));if(index>=0)show(index)};gallery.querySelector('[data-gallery-previous]')?.addEventListener('click',()=>show(active-1));gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(active+1));thumbnails.forEach((thumbnail,index)=>thumbnail.addEventListener('click',()=>show(index)));show(active)});
  document.addEventListener('change',event=>{const option=event.target.closest('[data-product-option]');if(!option)return;const section=option.closest('[data-product-section]');const info=section.querySelector('.noveo-product-info');const variants=JSON.parse(section.querySelector('[data-product-variants]').textContent);const selections=[...section.querySelectorAll('[data-product-option]:checked')].map(input=>input.value);const variant=variants.find(item=>item.options.every((value,index)=>value===selections[index]))||variants.find(item=>item.options.every((value,index)=>value===selections[index]||!selections[index]));if(!variant)return;const hidden=section.querySelector('[data-variant-id]');hidden.value=variant.id;const price=info.querySelector('[data-current-price]');const regularPrice=info.querySelector('[data-regular-price]');const button=info.querySelector('[data-add-button]');const formatPrice=value=>`€${(Number(value)/100).toFixed(2).replace('.',',')}`;if(regularPrice){regularPrice.textContent=formatPrice(variant.price);price.textContent=formatPrice(Math.round(Number(variant.price)*.75))}else{price.textContent=formatPrice(variant.price)}button.disabled=!variant.available;button.textContent=button.disabled?button.dataset.unavailableLabel:button.dataset.availableLabel;if(variant.featured_media?.id)section.querySelector('[data-product-gallery]')?.showMedia(variant.featured_media.id);const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url)});
  document.addEventListener('click',event=>{const button=event.target.closest('[data-quantity-decrease],[data-quantity-increase]');if(!button)return;const control=button.closest('.noveo-quantity-control');const input=control.querySelector('input[name="quantity"]');const minimum=Number(input.min)||1;const maximum=Number(input.max)||Infinity;const step=Number(input.step)||1;const direction=button.hasAttribute('data-quantity-increase')?1:-1;const current=Number(input.value)||minimum;input.value=String(Math.min(maximum,Math.max(minimum,current+direction*step)));input.dispatchEvent(new Event('change',{bubbles:true}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-recommendations]').forEach(container=>{if(container.dataset.loaded==='true')return;container.dataset.loaded='true';fetch(container.dataset.url).then(response=>response.text()).then(text=>{const html=new DOMParser().parseFromString(text,'text/html');const incoming=html.querySelector('[data-product-recommendations]');if(incoming?.innerHTML.trim())container.innerHTML=incoming.innerHTML}).catch(()=>{})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["withdrawal-form"]) return;
  try {
    
  document.querySelectorAll('.noveo-withdrawal__form').forEach((form) => {
    const storageKey = 'noveo-withdrawal-request';
    form.addEventListener('submit', () => {
      const timestamp = form.querySelector('[data-withdrawal-timestamp]');
      const submittedAt = new Date().toISOString();
      if (timestamp) timestamp.value = submittedAt;

      const data = new FormData(form);
      const request = {
        email: data.get('contact[email]'),
        firstName: data.get('contact[first_name]'),
        lastName: data.get('contact[last_name]'),
        orderNumber: data.get('contact[order_number]'),
        products: data.get('contact[products]'),
        quantity: data.get('contact[quantity]'),
        receivedAt: data.get('contact[received_at]'),
        reason: data.get('contact[reason]'),
        submittedAt,
        eventSent: false
      };
      sessionStorage.setItem(storageKey, JSON.stringify(request));
    });

    const success = form.querySelector('[data-withdrawal-success]');
    if (!success) return;

    try {
      const request = JSON.parse(sessionStorage.getItem(storageKey));
      if (!request || !request.email || request.eventSent) return;

      window._learnq = window._learnq || [];
      window._learnq.push(['identify', {
        '$email': request.email,
        '$first_name': request.firstName,
        '$last_name': request.lastName
      }]);
      window._learnq.push(['track', 'Withdrawal Request Submitted', {
        'Order Number': request.orderNumber,
        'Products': request.products,
        'Quantity': request.quantity,
        'Received At': request.receivedAt,
        'Reason': request.reason,
        'Submitted At': request.submittedAt
      }]);
      request.eventSent = true;
      sessionStorage.setItem(storageKey, JSON.stringify(request));
    } catch (error) {
      return;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
